import React from 'react'
import './anons-slider.scss'
import LeftIco from '../../../f/svg/left.svg'
import RightIco from '../../../f/svg/right.svg'

const AnonsSlider = ({ worksId: worksIdProp, className, sideColorNext, sideColorLast }) => {
  const itemsRef = React.useRef([])
  const slider = React.useRef()
  const currentIndex = React.useRef(0)

  const [worksId, setWorksId] = React.useState(worksIdProp || [])
  const [loading, setLoading] = React.useState(!worksIdProp)
  const [activeIndex, setActiveIndex] = React.useState(0)

  const [worksData, setWorksData] = React.useState([])

  const isWhite = ({ r, g, b }) => r * 0.299 + g * 0.587 + b * 0.114 <= 186

  React.useEffect(() => {
    const load = async () => {
      const data = await Promise.all(
        worksId.map(ids =>
          fetch(
            `https://www.artlebedev.ru/svalka/api/2019/?lang_id=1&data=works&works_custom_ids=${ids}&works_custom_ids_sort=1&works_offset=0&works_limit=30&works_not_update_price=1`
          ).then(r => r.json())
        )
      )
      setWorksData(data)
    }
    load()
  }, [])

  const renderMedia = (work) => {
    if(window.innerWidth < 900){
      return (<img src={work.img} className='anons-image' />)
    }
    if (work.preview.type == 'image') {
      return (
        <img src={work.preview.src} className='anons-image' />
      )
    }
    else if (work.preview.type == 'video') {
      return (
        <video autoPlay muted loop poster={work.preview.data.poster} className='anons-image'>
          {work.preview.data.video.map((video, i) => (
            <source key={video.src || i} src={video.src} type={video.type} />
          ))}
        </video>
      )
    }
    else{
      return (<img src={work.img} className='anons-image' />)
    }
  }

  const slide = React.useCallback((direction) => {
    if (!slider.current || !itemsRef.current.length) {
      return
    }

    slider.current.classList.remove('left', 'right')
    slider.current.classList.remove('moving')
    slider.current.classList.add(direction < 0 ? 'left' : 'right')
    setTimeout(() => {
      slider.current.classList.add('moving')
    }, 50)

    currentIndex.current =
      (currentIndex.current + direction + itemsRef.current.length) %
      itemsRef.current.length

    setActiveIndex(currentIndex.current)

    itemsRef.current.forEach((item, index) => {
      if (item) {
        item.classList.toggle('active', index === currentIndex.current)
        item.classList.toggle('hidden', index !== currentIndex.current)
      }
    })
  }, [])

  React.useEffect(() => {
    setActiveIndex(0)
  }, [worksId])

  React.useEffect(() => {
    itemsRef.current.forEach((item, index) => {
      if (item) {
        item.classList.toggle('active', index === 0)
        item.classList.toggle('hidden', index !== 0)
      }
    })
  }, [worksId])

  if (loading || !worksId.length) {
    return null
  }

  return (
    <div className={`slider-portfolio ${className || ''}`} ref={slider} id='anons-slider' style={{ '--next-color': sideColorNext, '--last-color': sideColorLast }}>

      {worksData.length >= 2 && (
        <>
          <div className='arrow left' onClick={() => slide(-1)}>
            <img src={LeftIco} alt='Назад' />
          </div>

          <div className='mini-slider'>
            {worksData.map((_, i) => (
              <div
                key={i}
                className={`mini-slider-item ${i === activeIndex ? 'active' : ''}`}
              />
            ))}
          </div>

          <div className='arrow right' onClick={() => slide(1)}>
            <img src={RightIco} alt='Вперед' />
          </div>
        </>
      )}

      

      {Array.isArray(worksData) && worksData.map((item, i, arr) => (
        <div
          key={i}
          className={`portfolio-item ${i === 0 ? 'active' : 'hidden'}`}
          style={{ zIndex: arr.length - i }}
          ref={el => itemsRef.current[i] = el}
        >
          {item.works?.list && item.works?.list.map((work) => (
            <div key={work.id || work.url} className={`anons-item-wrapper anons-size-${work.type}`}>
              <a href={work.url} target='_blank' className='anons-item'>
                {renderMedia(work)}
                <div
                  className={`anons-title ${isWhite(work.img_color) ? 'white-color' : 'black-color'
                    }`}
                  style={{
                    '--r': work.img_color.r,
                    '--g': work.img_color.g,
                    '--b': work.img_color.b
                  }}
                ><span dangerouslySetInnerHTML={{ __html: work.title }}/></div>
              </a>
            </div>
          ))}
        </div>
      ))}

    </div>
  )
}

export default AnonsSlider
